import React from 'react';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import RelationList from './DownloadItemList';

const Relations = () => {
  const breadcrumbs = [
    { label: 'لیست فیلم‌ها', link: '/' },
    { label: 'مدیریت ارتباطات', isActive: true },
  ];

  return (
    <PageContainer breadcrumbs={breadcrumbs} heading={'مدیریت ارتباطات'}>
      <RelationList />
    </PageContainer>
  );
};

export default Relations;
